import { useNavigate, useParams } from 'react-router-dom'
import { useGetQuery, usePostQuery } from 'hooks'
import { Card, Title } from 'components'
import { NpcAdminForm } from './form'
import { NpcDungeonList } from './dungeon-list'

export const AdminNpcEdit = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const { data, isFetching } = useGetQuery({ url: `/admin/npcs/${id}` })
  const { post: updateNpc } = usePostQuery({ url: `/admin/npcs/${id}`, method: 'PUT' })
  const npc = data?.npc

  const handleSubmit = async (payload) => {
    await updateNpc(payload)
    navigate('/admin/npcs')
  }

  if (isFetching || !npc) return null

  return (
    <Card margin="0.5rem">
      <Title level={3} color="link">{npc.name}</Title>
      <NpcAdminForm initial={npc} onSubmit={handleSubmit} submitLabel="Save Changes" />
      <NpcDungeonList npc={npc} />
    </Card>
  )
}
